import styleUtils from "../styles/utils.module.css";

const NotFoundPage = () => {
  return (
    <>
      <h1
        className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}
        style={{ fontSize: "6rem" }}
      >
        404 - oops!
      </h1>
      <br />
      <h4 className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}>
        The page that you're trying to access doesn't exist.
      </h4>
    </>
  );
};

export default NotFoundPage;
